import React from "react";
import { hooks } from "../../../utils";
import PreservedAreasTable from "../components/PreservedAreasTable";
import { api } from "../../../services";
import { Spacing } from "../../../config";
import { CircularProgress } from "@material-ui/core";
import Styles from "../styles/Styles";
import { errorModal } from "../../../components/modals/utils";

function Container() {
  const { loading, call } = hooks.useRequest();
  const [PageNumber, setPageNumber] = React.useState<any>(1);
  const [pageSize, setPageSize] = React.useState<any>(5);
  const [PreservedAreasData, setPreservedAreasData] = React.useState<any>(null);
  const [currentButton, setCurrentButton] = React.useState<boolean>(true);
  const FilterTable = React.useRef<any>();

  const Mount = React.useCallback(() => {
    errorModal.setInfos("Carregando", ["aguarde..."], null, null);
    call(
      "AreasTable",
      api.GetPreservedAreasList({
        page: 0,
        size: pageSize,
        filter: "",
        acquired: true,
      }),
      async (response) => {
        if (response.ok) {
          let newList: any[] = [];
          for (const item of response?.data?.content) {
            await call(
              null,
              api.GetPreservedAreaImage(item.id, item.imageId1),
              (response) => {
                newList.push({ ...item, img: response?.data });
              }
            );
          }
          setCurrentButton(true);
          setPageNumber(1);
          setPreservedAreasData({ ...response.data, content: newList });
        }
      }
    );

    //errorModal.close();
  }, []);
  
  React.useEffect(Mount, [Mount]);

  const GetCurrentTable = (pageNumber, acquired) => {
    call(
      null,
      api.GetPreservedAreasList({
        page: pageNumber - 1,
        size: pageSize,
        filter: "",
        acquired: acquired,
      }),
      async (response) => {
        if (response.ok) {
          let newList: any[] = [];
          for (const item of response?.data?.content) {
            await call(
              null,
              api.GetPreservedAreaImage(item.id, item.imageId1),
              (response) => {
                newList.push({ ...item, img: response?.data });
              }
            );
          }
          setPreservedAreasData({ ...response.data, content: newList });
        }
      }
    );
  };

  const GetPage = (newPage: number, newPageSize?: any) => {
    errorModal.setInfos("Carregando", ["aguarde..."], null, null);
    if (newPageSize) {
      setPageSize(newPageSize);
    }
    call(
      "AreasTable",
      api.GetPreservedAreasList({
        page: newPage - 1,
        size: newPageSize ? newPageSize : pageSize,
        filter: FilterTable.current,
        acquired: currentButton,
      }),
      async (response) => {
        if (response.ok) {
          let newList: any[] = [];
          for (const item of response?.data?.content) {
            await call(
              null,
              api.GetPreservedAreaImage(item.id, item.imageId1),
              (response) => {
                newList.push({ ...item, img: response?.data });
              }
            );
          }
          setPageNumber(newPage);
          setPreservedAreasData({ ...response.data, content: newList });
        }
      }
    );
  };

  const getSelectedFilterTable = (data) => {
    errorModal.setInfos("Carregando", ["aguarde..."], null, null);
    call(
      null,
      api.GetPreservedAreasList({
        page: 0,
        size: pageSize,
        filter: data,
        acquired: currentButton,
      }),
      async (response) => {
        if (response.ok) {
          let newList: any[] = [];
          for (const item of response?.data?.content) {
            await call(
              null,
              api.GetPreservedAreaImage(item.id, item.imageId1),
              (response) => {
                newList.push({ ...item, img: response?.data });
              }
            );
          }
          setPreservedAreasData({ ...response.data, content: newList });
        }
      }
    );
  };

  return (
    <>
      {loading ? (
        <Styles.LoadingContainer>
          <CircularProgress
            size={120}
            style={{
              color: "black",
              alignSelf: "center",
              justifyContent: "center",
              marginBlock: Spacing(3),
            }}
          />
        </Styles.LoadingContainer>
      ) : (
        <PreservedAreasTable
          size={pageSize}
          page={PageNumber}
          setPage={GetPage}
          tableData={PreservedAreasData}
          loadTable={Mount}
          loading={loading}
          ResquestFilterValue={FilterTable}
          sendSelectedFilter={getSelectedFilterTable}
          currentButton={currentButton}
          setCurrentButton={setCurrentButton}
          getCurrentTable={GetCurrentTable}
        />
      )}
    </>
  );
}

export default Container;
